export const wallboardTemplate1 = [
  {
    id: '518b2716-615f-0820-a467-8caa19b1d5f9',
    type: 'META',
    backgroundColor: 'rgba(0,0,0,0)',
    backgroundImage: '',
  },
  {
    id: '97862a16-615e-0820-c467-8caa39b1d5f9',
    type: 'INDICATOR',
    color: '#ffffff',
    background: '#000000',
    title: '2',
    sizeX: 6,
    sizeY: 2,
    row: 1,
    col: 6,
    edited: false,
    array: [],
    new: false,
    display: 'GRID',
    titleSize: 'MEDIUM',
  },
  {
    id: '8956d3e1-d8ad-319e-f7ca-608189c5f09f',
    type: 'TEXT',
    background: '#ffffff',
    name: '1',
    text: 'ABC',
    sizeX: 10,
    sizeY: 1,
    row: 0,
    col: 2,
    edited: false,
    new: false,
  },
  {
    id: '498a82d5-3d14-8710-cff0-38ca6396afba',
    type: 'DATETIME',
    color: '#000000',
    background: '#ffffff',
    format: 'MMMM Do YYYY HH:mm',
    sizeX: 2,
    sizeY: 1,
    row: 0,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: 'c63b918d-9d66-77d9-eb63-b8c810782486',
    type: 'INDICATOR',
    color: '#ffffff',
    background: '#000000',
    title: '1',
    sizeX: 6,
    sizeY: 2,
    row: 1,
    col: 0,
    edited: false,
    new: false,
    array: [
      {
        id: '48faa488-271a-123a-5826-0183c01c94ad',
        title: '1.1',
        color: '#ffffff',
        background: 'rgba(255,255,255,0.35)',
        type: 'STATIC',
        value: '-',
        sizeX: 3,
        sizeY: 2,
        edited: false,
        row: 0,
        col: 0,
        refreshMinutes: 0,
        refreshSeconds: 5,
      },
    ],
    display: 'GRID',
    titleSize: 'MEDIUM',
  },
  {
    id: 'e76e03ac-ed0b-ea43-2fe0-8925fcfb7b6b',
    type: 'TEXT',
    background: '#ffffff',
    name: '2',
    text: 'ABC',
    sizeX: 12,
    sizeY: 1,
    row: 5,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: 'e191b2ae-2476-10ac-f2a5-fe25583c8824',
    type: 'INDICATOR',
    color: '#ffffff',
    background: '#000000',
    title: '3',
    sizeX: 6,
    sizeY: 2,
    row: 3,
    col: 0,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '31ba449d-d070-a112-f627-bc7470b04d50',
    type: 'INDICATOR',
    color: '#ffffff',
    background: '#000000',
    title: '4',
    sizeX: 6,
    sizeY: 2,
    row: 3,
    col: 6,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
];

export const wallboardTemplate2 = [
  {
    id: '518b2716-615f-0820-a467-8caa19b1d5f9',
    type: 'META',
    backgroundColor: 'rgba(0,0,0,0)',
    backgroundImage: '',
  },
  {
    id: '97862a16-615e-0820-c467-8caa39b1d5f9',
    type: 'INDICATOR',
    color: '#ffffff',
    background: 'rgba(0,0,0,0.73)',
    title: '2',
    sizeX: 9,
    sizeY: 2,
    row: 1,
    col: 3,
    edited: false,
    array: [],
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '8956d3e1-d8ad-319e-f7ca-608189c5f09f',
    type: 'TEXT',
    background: '#ffffff',
    name: '1',
    text: 'ABC',
    sizeX: 10,
    sizeY: 1,
    row: 0,
    col: 2,
    edited: false,
    new: false,
  },
  {
    id: '498a82d5-3d14-8710-cff0-38ca6396afba',
    type: 'DATETIME',
    color: '#000000',
    background: '#ffffff',
    format: 'HH:mm',
    sizeX: 2,
    sizeY: 1,
    row: 0,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: 'c63b918d-9d66-77d9-eb63-b8c810782486',
    type: 'INDICATOR',
    color: '#ffffff',
    background: 'rgba(0,0,0,0.73)',
    title: '1',
    sizeX: 3,
    sizeY: 4,
    row: 1,
    col: 0,
    edited: false,
    new: false,
    array: [
      {
        id: '48faa488-271a-123a-5826-0183c01c94ad',
        title: '1.1',
        color: '#fff9d8',
        background: 'rgba(255,255,255,0.31)',
        type: 'STATIC',
        value: '-',
        sizeX: 10,
        sizeY: 3,
        edited: false,
        row: 0,
        col: 0,
        refreshMinutes: null,
        refreshSeconds: null,
      },
    ],
    titleSize: 'LARGE',
    display: 'GRID',
  },
  {
    id: 'e76e03ac-ed0b-ea43-2fe0-8925fcfb7b6b',
    type: 'TEXT',
    background: '#ffffff',
    name: '2',
    text: 'ABC',
    sizeX: 12,
    sizeY: 1,
    row: 5,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: '31ba449d-d070-a112-f627-bc7470b04d50',
    type: 'INDICATOR',
    color: '#ffffff',
    background: 'rgba(0,0,0,0.73)',
    title: '3',
    sizeX: 9,
    sizeY: 2,
    row: 3,
    col: 3,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
];

export const wallboardTemplate3 = [
  {
    id: '518b2716-615f-0820-a467-8caa19b1d5f9',
    type: 'META',
    backgroundColor: 'rgba(0,0,0,0)',
    backgroundImage: '',
  },
  {
    id: '97862a16-615e-0820-c467-8caa39b1d5f9',
    type: 'INDICATOR',
    color: '#000000',
    background: 'rgba(93,113,255,0.75)',
    title: '1',
    sizeX: 12,
    sizeY: 1,
    row: 1,
    col: 0,
    edited: false,
    array: [],
    new: false,
    titleSize: 'SMALL',
    display: 'GRID',
  },
  {
    id: '8956d3e1-d8ad-319e-f7ca-608189c5f09f',
    type: 'TEXT',
    background: '#ffffff',
    name: '1',
    text: 'ABC',
    sizeX: 10,
    sizeY: 1,
    row: 0,
    col: 2,
    edited: false,
    new: false,
  },
  {
    id: '498a82d5-3d14-8710-cff0-38ca6396afba',
    type: 'DATETIME',
    color: '#000000',
    background: '#ffffff',
    format: 'HH:mm',
    sizeX: 2,
    sizeY: 1,
    row: 0,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: 'c63b918d-9d66-77d9-eb63-b8c810782486',
    type: 'INDICATOR',
    color: '#000000',
    background: 'rgba(255,18,18,0.75)',
    title: '2',
    sizeX: 3,
    sizeY: 4,
    row: 2,
    col: 0,
    edited: false,
    new: false,
    array: [
      {
        id: '48faa488-271a-123a-5826-0183c01c94ad',
        title: '2.1',
        color: '#fff7cc',
        background: 'rgba(0,0,0,0.33)',
        type: 'STATIC',
        value: 'ABC',
        sizeX: 5,
        sizeY: 4,
        edited: false,
        row: 0,
        col: 0,
        refreshMinutes: null,
        refreshSeconds: null,
      },
    ],
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '31ba449d-d070-a112-f627-bc7470b04d50',
    type: 'INDICATOR',
    color: '#000000',
    background: 'rgba(97,241,71,0.71)',
    title: '3',
    sizeX: 9,
    sizeY: 4,
    row: 2,
    col: 3,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '035255a4-9f65-b7ea-6c07-a3fa5b4569bc',
    type: 'INDICATOR',
    color: '#000000',
    background: 'rgba(213,215,50,0.71)',
    title: '4',
    sizeX: 12,
    sizeY: 1,
    row: 6,
    col: 0,
    array: [],
    edited: false,
    new: false,
    titleSize: 'SMALL',
    display: 'GRID',
  },
];

export const wallboardTemplate4 = [
  {
    id: '518b2716-615f-0820-a467-8caa19b1d5f9',
    type: 'META',
    backgroundColor: 'rgba(0,0,0,0)',
    backgroundImage: '',
  },
  {
    id: '97862a16-615e-0820-c467-8caa39b1d5f9',
    type: 'INDICATOR',
    color: '#000000',
    background: '#ffffff',
    title: '2',
    sizeX: 2,
    sizeY: 2,
    row: 1,
    col: 10,
    edited: false,
    array: [],
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '8956d3e1-d8ad-319e-f7ca-608189c5f09f',
    type: 'TEXT',
    background: '#ffffff',
    name: '1',
    text: 'ABC',
    sizeX: 6,
    sizeY: 1,
    row: 0,
    col: 6,
    edited: false,
    new: false,
  },
  {
    id: 'c63b918d-9d66-77d9-eb63-b8c810782486',
    type: 'INDICATOR',
    color: '#000000',
    background: '#ffffff',
    title: '1',
    sizeX: 10,
    sizeY: 2,
    row: 1,
    col: 0,
    edited: false,
    new: false,
    array: [
      {
        id: '48faa488-271a-123a-5826-0183c01c94ad',
        title: '1.1',
        color: '#fff8d6',
        background: 'rgba(0,0,0,0.43)',
        type: 'STATIC',
        value: 'ABC',
        sizeX: 3,
        sizeY: 1,
        edited: true,
        row: 0,
        col: 0,
        refreshMinutes: null,
        refreshSeconds: null,
      },
    ],
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: 'e76e03ac-ed0b-ea43-2fe0-8925fcfb7b6b',
    type: 'TEXT',
    background: '#ffffff',
    name: '2',
    text: 'ABC',
    sizeX: 12,
    sizeY: 1,
    row: 5,
    col: 0,
    edited: false,
    new: false,
  },
  {
    id: 'e191b2ae-2476-10ac-f2a5-fe25583c8824',
    type: 'INDICATOR',
    color: '#000000',
    background: '#ffffff',
    title: '3',
    sizeX: 2,
    sizeY: 2,
    row: 3,
    col: 0,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '31ba449d-d070-a112-f627-bc7470b04d50',
    type: 'INDICATOR',
    color: '#000000',
    background: '#ffffff',
    title: '4',
    sizeX: 10,
    sizeY: 2,
    row: 3,
    col: 2,
    array: [],
    edited: false,
    new: false,
    titleSize: 'MEDIUM',
    display: 'GRID',
  },
  {
    id: '66eeee91-a076-f423-b7eb-f4ada9093057',
    type: 'DATETIME',
    color: '#ffffff',
    background: '#000000',
    format: 'HH:mm:ss',
    sizeX: 4,
    sizeY: 1,
    row: 0,
    col: 2,
    edited: false,
    new: false,
  },
  {
    id: '946f79e1-2a9c-9b4d-953d-9ff39807e59e',
    type: 'DATETIME',
    color: '#000000',
    background: '#ffffff',
    format: 'DD/MM/YY',
    sizeX: 2,
    sizeY: 1,
    row: 0,
    col: 0,
    edited: false,
    new: false,
  },
];
